const LegendItem = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <span
      className="w-3 h-3 rounded-full"
      style={{ backgroundColor: color }}
    ></span>
    <span className="text-sm">{label}</span>
  </div>
);

const CalendarLegend = () => (
  <div className="flex gap-4 mb-4 flex-wrap items-center">
    <span className="font-semibold text-sm">Excursiones:</span>
    <LegendItem color="#faad14" label="Pendiente" />
    <LegendItem color="#1890ff" label="En progreso" />
    <LegendItem color="#ff4d4f" label="Sin lugar" />
    <LegendItem color="#52c41a" label="Finalizada" />

    <span className="ml-4 font-semibold text-sm">Grupos:</span>
    <LegendItem color="#1890ff" label="Check In" />
    <LegendItem color="#faad14" label="Check Out" />

    <span className="ml-4 font-semibold text-sm">Tareas:</span>
    <LegendItem color="#F59E0B" label="Pendiente" />
    <LegendItem color="#3B82F6" label="En progreso" />
    <LegendItem color="#10B981" label="Completada" />
  </div>
);

export default CalendarLegend;
